import { render, staticRenderFns } from "./df-card-banner.vue?vue&type=template&id=ff0225bc&"
import script from "./df-card-banner.ts?vue&type=script&lang=js&"
export * from "./df-card-banner.ts?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports